'use strict';

var buildRelativeAliases = require('../internal/buildRelativeAliases');

buildRelativeAliases();


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/build/buildRelativeAliasesCall.js
// module id = 304
// module chunks = 0